import React from "react";
import "./Info.css";
const Info = () => {
  return (
    <div
      className="info"
      style={{ backgroundColor: "white", alignItems: "flex-end" }}
    >
      <div className="heading-container">
        <div className="heading">Tiranga Pheri 14 August, 2023</div>
        <div className="heading-line"></div>
      </div>
      <div className="text1">
      The spirit of unity and patriotism will be vividly displayed as we call upon all students, faculty, staff members, and NCC Cadets to gather in front of the administration building for a memorable event. At 5:00 pm, we will commence the "Tiranga Pheri," a spirited march that will encompass the entire campus, symbolizing the ideals of our freedom struggle and the unity that binds our diverse community.

This march, beginning at the administrative building and stretching up to Peepalgaon police boot before looping back to the IIIT campus, will be a visible representation of our commitment to our country and our institution. It's a moment for us to come together and walk the path of progress, carrying the tricolor high.
      </div>
      <div className="text2">
        You are requested to take their selfies with the tiranga
        visible in it and upload it to the given link : <a href="/login"> <b>Upload Photos</b></a>   
      </div>
      <div className="extra">
        <div className="date">
          <span style={{ fontWeight: "bold" }}>Date</span>: 14 August, 2023
        </div>
        {/* <div className="time">Time: 4:00 PM</div>
        <div className="location">Venue: Adminsitrative Building</div> */}
      </div>
    </div>
  );
};

export default Info;
